export default __webpack_public_path__ + "static/media/GPA_Launch_HomeBanner.05ef21d6.mp4";